import { createRouter, createWebHistory } from 'vue-router'

import CorsiView from '../views/CorsiView.vue'
import DashboardView from '../views/DashboardView.vue'
import DatiAziendaliView from '../views/DatiAziendaliView.vue'
import LoginView from '../views/LoginView.vue'
import PersonaleView from '../views/PersonaleView.vue'

const routes = [

  {
    path: '/corsi',
    name: 'corsi',
    component: CorsiView
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView
  },
  {
    path: '/dati-aziendali',
    name: 'dati-aziendali',
    component: DatiAziendaliView
  },
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/personale',
    name: 'personale',
    component: PersonaleView
  },
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
